import { useState, useEffect } from 'react'
import api from '../../../../utils/axiosInstance'
import { USE_MOCK } from '../../../../utils/mock/mockFlag'
import { mockVarList } from '../../../../utils/mock/mockData'
import { getApiBaseUrl } from '../../../../utils/defines/apiUrl'

export interface VarItem { campo: string; label: string }
export interface Categoria { nome: string; variaveis: VarItem[] }

export function useVarList(token: string) {
    const [categorias, setCategorias] = useState<Categoria[]>([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        if (USE_MOCK) { setCategorias(mockVarList.categorias); return }
        if (!token) return

        setLoading(true)
        api.get(`${getApiBaseUrl()}/graficos/variaveis?token=${encodeURIComponent(token)}`)
            .then(r => setCategorias(r.data.categorias ?? []))
            .catch(e => setError(e.message))
            .finally(() => setLoading(false))
    }, [token])

    return { categorias, loading, error }
}
